import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { formValueSelector, Field } from "redux-form";
import { LockClosedIcon } from "@heroicons/react/24/solid";
import _ from "lodash";
import { updatedAllowCCEmails } from "@ticketsaction";
import { TICKET_FOLDER } from "@constant";
import {
  renderFieldText,
  renderHiddenFieldText,
  renderSingleCheckbox,
  renderFieldSelect,
} from "@basecomponent";
import LocaleStrings from "@language";
import visa from "../../../assets/image/visa.png";
import mastercard from "../../../assets/image/mastercard.png";
import americanexpress from "../../../assets/image/american-express.png";

const BuyerInfo = (props) => {
  const location = useLocation();
  let {
    disableFields,
    isProposalTicket,
    selfAssign,
    eventSettingsData,
    manageTicketsCount,
    allowCCEmails,
    isinvoice,
    countryList,
  } = props;
  // console.log("manageTicketsCount :- ", manageTicketsCount);
  // console.log("eventSettingsData :- ", eventSettingsData);
  // console.log("allowCCEmails :- ", allowCCEmails);

  let params = location.search;

  let customEventSettings = JSON.parse(
    eventSettingsData?.data?.custom_settings ?? "{}"
  );

  // Check is buyer more company info visiavle or not
  let showMoreFields = true;
  if (customEventSettings?.showticketbuyermorefields === false) {
    showMoreFields = false;
  }
  // Check buyer additional company info mandatory or not
  let madatoryAdditionalFields = false;
  if (
    customEventSettings?.showticketbuyermorefields &&
    customEventSettings?.mandatorybuyeradditionalinfo
  ) {
    madatoryAdditionalFields = true;
  }

  // Check setting to show refund policy or not
  let showRefundPolicy = eventSettingsData?.data?.showrefundpolicy ?? true;

  let checkHasChild = _.filter(manageTicketsCount, (obj) => obj?.haschild); // Check if any ticket with associated child ticket available in order
  // console.log("checkHasChild :- ", checkHasChild);

  const handleCCEmails = () => {
    props.autofill("additionalemail", undefined);

    props.updatedAllowCCEmails({ allow: !allowCCEmails.allow });
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-x-2 base-form">
        <Field
          name="currentstep"
          type="text"
          component={renderHiddenFieldText}
        />
        <div className="BUYER_FULL_NAME col-span-2">
          <Field
            name="name"
            label={LocaleStrings.kLabelFullName}
            placeholder={LocaleStrings.kPlaceholderFullName}
            type="text"
            component={renderFieldText}
            mandatory={true}
            maxlength={150}
            disabled={disableFields || isProposalTicket}
          />
        </div>
        <div className="BUYER_EMAIL col-span-2">
          <Field
            name="email"
            label={LocaleStrings.kEmail}
            placeholder={LocaleStrings.kEnterEmailAddress}
            type="text"
            component={renderFieldText}
            mandatory={true}
            maxlength={150}
            disabled={disableFields || isProposalTicket}
          />
        </div>
        <div className="BUYER_COUNTRY col-span-2">
          <Field
            name="country"
            label={LocaleStrings.kCountryText}
            placeholder={LocaleStrings.kPlaceholderCountry}
            component={renderFieldSelect}
            mandatory={true}
            options={_.map(countryList, (e) => ({
              value: e.country,
              text: e.country,
            }))}
            disabled={disableFields}
          />
        </div>
        <div
          className="BUYER_ADD_CC col-span-2 custom-text-theme-sm-bold text-right underline cursor-pointer select-none"
          onClick={handleCCEmails}
        >
          {allowCCEmails.allow
            ? LocaleStrings.kRemoveCCEmailsText
            : LocaleStrings.kAddCCEmailsText}
        </div>
        {allowCCEmails.allow ? (
          <div className="BUYER_ADDITIONAL_EMAIL col-span-2">
            <Field
              name="additionalemail"
              label={LocaleStrings.kAdditionalEmailForInvoice}
              placeholder={LocaleStrings.kEnterAdditionalEmailAddress}
              type="text"
              component={renderFieldText}
              mandatory={false}
              disabled={disableFields || isProposalTicket}
            />
          </div>
        ) : (
          ""
        )}
        {checkHasChild?.length > 0 ? (
          <div className="BUYER_COMPANY col-span-2">
            <Field
              name="company_name"
              label={LocaleStrings.kLabelCompanyName}
              placeholder={LocaleStrings.kPlaceholderCompanyName}
              type="text"
              component={renderFieldText}
              mandatory={true}
              maxlength={150}
              disabled={disableFields}
            />
          </div>
        ) : (
          ""
        )}

        {showMoreFields ? (
          <>
            <div className="BUYER_INVOICE col-span-2">
              <Field
                name="isinvoice"
                label={LocaleStrings.kIsBusinessInvoiceText}
                component={renderSingleCheckbox}
                type="checkbox"
                mandatory={madatoryAdditionalFields}
                disabled={disableFields}
              />
            </div>

            {isinvoice ? (
              <>
                <div
                  className={`BUYER_VAT col-span-2 ${
                    checkHasChild?.length === 0 ? "sm:col-span-1" : ""
                  }`}
                >
                  <Field
                    name="vat"
                    label={LocaleStrings.kLabelVatNo}
                    placeholder={LocaleStrings.kPlaceholderVatNo}
                    type="text"
                    component={renderFieldText}
                    maxlength={150}
                    disabled={disableFields}
                  />
                </div>
                {checkHasChild?.length === 0 ? (
                  <div className="BUYER_COMAPANY_NAME col-span-2 sm:col-span-1">
                    <Field
                      name="company_name"
                      label={LocaleStrings.kLabelBilledTo}
                      placeholder={LocaleStrings.kPlaceholderBilledTo}
                      type="text"
                      component={renderFieldText}
                      mandatory={true}
                      maxlength={150}
                      disabled={disableFields}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="BUYER_STREET col-span-2 sm:col-span-1">
                  <Field
                    name="street"
                    label={LocaleStrings.kLabelStreet}
                    placeholder={LocaleStrings.kPlaceholderStreet}
                    type="text"
                    component={renderFieldText}
                    mandatory={true}
                    maxlength={150}
                    disabled={disableFields}
                  />
                </div>
                <div className="BUYER_CITY col-span-2 sm:col-span-1">
                  <Field
                    name="city"
                    label={LocaleStrings.kLabelCity}
                    placeholder={LocaleStrings.kPlaceholderCity}
                    type="text"
                    component={renderFieldText}
                    mandatory={true}
                    maxlength={150}
                    disabled={disableFields}
                  />
                </div>
                <div className="BUYER_POSTAL col-span-2 sm:col-span-1">
                  <Field
                    name="postal"
                    label={LocaleStrings.kLabelPostal}
                    placeholder={LocaleStrings.kPlaceholderPostal}
                    type="text"
                    component={renderFieldText}
                    mandatory={true}
                    maxlength={150}
                    disabled={disableFields}
                  />
                </div>
                {/* <div className="BUYER_COUNTRY col-span-2 sm:col-span-1">
                  <Field
                    name="country"
                    label={LocaleStrings.kCountryText}
                    placeholder={LocaleStrings.kPlaceholderCountry}
                    component={renderFieldSelect}
                    mandatory={true}
                    options={_.map(countryList, (e) => ({
                      value: e.country,
                      text: e.country,
                    }))}
                    disabled={disableFields}
                  />
                </div> */}
              </>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}

        {showRefundPolicy && (
          <div className="BUYER_REFUND_POLICY col-span-2">
            <Field
              name="refund_policy"
              htmllabel={LocaleStrings.kRefundPolicyText.replace(
                "#RP",
                `<a href='${TICKET_FOLDER}/refund-policy${params}' target='_blank'><u><b>${LocaleStrings.KRefundPolicy}</b></u></a>`
              )}
              component={renderSingleCheckbox}
              type="checkbox"
              mandatory={true}
              disabled={disableFields}
            />
          </div>
        )}
        <div className="BUYER_TERMS col-span-2">
          <Field
            name="terms"
            htmllabel={LocaleStrings.kTandCAndPandPText
              .replaceAll(
                "#T&C",
                `<a href='${TICKET_FOLDER}/terms-conditions${params}' target='_blank'><u><b>${LocaleStrings.kTermsAndConditions}</b></u></a>`
              )
              .replaceAll(
                "#P&P",
                `<a href='${TICKET_FOLDER}/privacy-policy${params}' target='_blank'><u><b>${LocaleStrings.KPrivacyPolicy}</b></u></a>`
              )}
            component={renderSingleCheckbox}
            type="checkbox"
            mandatory={true}
            disabled={disableFields}
          />
        </div>
        {selfAssign ? (
          <div className="BUYER_SELF_ASSIGN col-span-2">
            <Field
              name="assign_himself"
              label={LocaleStrings.kTicketMySelfText}
              component={renderSingleCheckbox}
              type="checkbox"
              mandatory={false}
              disabled={disableFields}
            />
          </div>
        ) : (
          ""
        )}
      </div>

      {/* divider */}
      <div className="BUYER_DIVIDER relative py-6">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
      </div>
      {/* divider */}

      <div className="BUYER_VISA_CONTAINER flex items-center space-x-1">
        <div>
          <img src={visa} alt="visacard" />
        </div>
        <div>
          <img src={mastercard} alt="mastercard" />
        </div>
        <div>
          <img src={americanexpress} alt="americanexpresscard" />
        </div>
      </div>

      <div className="BUYER_TRANSACTION_MESSAGE flex space-x-2 mt-6">
        <LockClosedIcon className="w-6 h-6" />
        <span className="custom-text-primary-md-normal">
          {LocaleStrings.kTransactionSecureText}
        </span>
      </div>
    </>
  );
};

const selector = formValueSelector("TicketBuyerInfoForm");

const mapStateToProps = (state) => {
  return {
    eventSettingsData: state.eventSettingsData,
    manageTicketsCount: state.manageTicketsCount,
    allowCCEmails: state.allowCCEmails,
    countryList: state.countryList,

    isinvoice: selector(state, "isinvoice"),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updatedAllowCCEmails }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BuyerInfo);
